import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBreadcrumbs,{attrs:{"items":_vm.breadcrumbs,"divider":"/"}})}
var staticRenderFns = []

export { render, staticRenderFns }